export default __webpack_public_path__ + "static/media/cs-c003-right.e42a2a34.svg";